// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start

import { memo } from "react";
import { BzButton, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import ChangeHeaderIndicesModal from "./ChangeHeaderIndicesModal";
import { updateHeaderIndices } from "../../redux/actions/indices";
import { sendTouchlineRequest } from "../../apis/web_socket";



const HeaderIndices = ({ indices }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const headerIndices = useSelector(state => state?.indices?.headerIndices);

    const handleClose = () => {
        dispatch(handleModal([{ "HEADER_INDICES": false }]));
    };

    return (
        <>
            {/* Sumit G - 19-12-2023 starts here*/}
            {modals['HEADER_INDICES'] && <>
                <BzModal data-testid="choose-indices-popup" show={modals['HEADER_INDICES']} onHide={handleClose} centered>
                    <BzModalHeader className='modaltabs-header'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col data-testid="choose-indices-popup-title-text" md={11} className='d-flex justify-content-start align-self-center'>
                                    <div className='font-medium font-size4 color-text'>Choose Indices</div>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                    <div data-testid="choose-indices-popup-close-icon" className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody>
                        <Container fluid className='p-0 my-2'>
                            <Row className='g-0'>
                                {indices.map((obj, i) => {
                                    return (
                                        <Col md={4} key={i}>
                                            <div className='header-indices-card-wrapper'>
                                                <div className='header-indices-cards'>
                                                    <Container fluid className='p-0'>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex flex-column align-items-start'>
                                                                <div data-testid="choose-indices-scrip-name-label" className='font-medium indices-scripname color-text text-uppercase'>{obj?.sIndexDesc?.length > 12 ? `${obj?.sIndexDesc.slice(0, 12)}...` : obj?.sIndexDesc}</div>
                                                                <div data-testid="choose-indices-ltp-label" className={`font-medium indices-ltp color-text py-1 ${obj?.netChangeIndicator > 0 ? 'color-positive' : 'color-negative'}`}>{obj?.LTP}</div>
                                                                <div data-testid="choose-indices-changepercent-label" className={`font-semibold indices-changepercent color-text ${obj?.netChangeIndicator > 0 ? 'color-positive' : 'color-negative'}`}>{obj?.netChange} ({obj?.netChangeIndicator}%)</div>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                    <Container fluid className='p-0'>
                                                        <Row className='g-0 mt-3'>
                                                            <Col className='d-flex align-items-start'>
                                                                <BzButton data-testid="choose-indices-change-button" className={`btn btn-sm btn-primary`} onClick={() => {
                                                                    dispatch(handleModal([{ "CHANGE_HEADER_INDICES": true }]));
                                                                    dispatch(handleModalData({ data: obj, index: i }));
                                                                }}>Change
                                                                </BzButton>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Container>
                    </BzModalBody>
                </BzModal>
                {/* Sumit G - 19-12-2023 ends here*/}
                <ChangeHeaderIndicesModal onSelect={(selectedObj, index) => {
                    let temp = headerIndices.map((x, i) => {
                        if (i === index) {
                            return selectedObj;
                        }
                        return x;
                    });
                    sendTouchlineRequest([{
                        exchangeId: selectedObj?.nMarketSegmentId,
                        token: selectedObj?.nToken,
                        isSubscribe: true,
                    }]);
                    dispatch(updateHeaderIndices(temp));
                }} />
            </>}

        </>
    );
};

export default memo(HeaderIndices);

// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices End
